
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.519 18.192l-1.696-.572V9.817l1.696-.571v8.946zm-9.341-5.799l5.645-1.902v6.455l-5.645-1.901v-2.652zm-2 7.122H7.596l.111-10.396h8.735c.893 0 1.671-.483 2.103-1.198h9.633v11.594zM5 6.65V5.468A.47.47 0 015.468 5h10.974a.47.47 0 01.468.468V6.65c0 .259-.21.469-.468.469H5.468A.469.469 0 015 6.65zm36.102.392a.995.995 0 00-.902-.136l-10.022 3.377V6.921a1 1 0 00-1-1H18.91v-.453A2.471 2.471 0 0016.442 3H5.468A2.471 2.471 0 003 5.468V6.65a2.472 2.472 0 002.468 2.469h.238l-.121 11.386a1 1 0 001 1.011h10.466l-7.03 18.347a.998.998 0 101.867.715l5.696-14.865v11.574a1 1 0 002 0V25.525l5.768 15.053a.999.999 0 101.867-.715L20.19 21.516h8.988a1 1 0 001-1.001v-3.36L40.2 20.532a1 1 0 001.319-.948V7.853a.996.996 0 00-.417-.811z","fill-rule":"evenodd"}})])
          )
        }
      }
    